export function receiptState(receipt: any): 'issued' | 'historical' | 'waiting' | 'disputed' {
 if (!receipt || receipt.status !== 'ISSUED') return 'waiting';
 if (receipt.disputed === true) return 'disputed';
 if (!receipt.native || receipt.historical === true) return 'historical';
 if (receipt.workflow_state !== 'QUITTANCE_ISSUED' || !receipt.cleared_at || !Number.isFinite(Date.parse(receipt.cleared_at)) || receipt.settled !== true || receipt.pending_payment !== false) return 'waiting';
 return 'issued';
}

export function receiptPDFPath(receipt: {id:string; native:boolean}): string {
 return receipt.native ? `/api/v1/receipts/${encodeURIComponent(receipt.id)}/pdf` : `/api/v1/fpt/quittances/${encodeURIComponent(receipt.id)}/pdf`;
}

export const paymentMethod = (channel: string) => ({IZZI:'IzziPay',IZZIPAY:'IzziPay',MPESA:'M-Pesa',ORANGE_MONEY:'Orange Money',AIRTEL_MONEY:'Airtel Money',CARD:'Carte bancaire',BCC_TRANSFER:'Virement bancaire',BANK_TRANSFER:'Virement bancaire',BANK_DEPOSIT:'Versement bancaire',CASH:'Espèces',WALLET:'Portefeuille'} as Record<string,string>)[channel] || channel || 'Non renseigné';
